// // TokenSync.js
// import { useEffect } from 'react';

// const TokenSync = () => {
//     useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         const token = urlParams.get('token');
//         const type = urlParams.get('type');
//         const encodedLoginData = urlParams.get('loginData');

//         if (token && type) {
//             localStorage.setItem('type', type);
//             if (type === 'E') {
//                 localStorage.setItem('agenttoken', token);
//                 if (encodedLoginData) {
//                     const loginData = JSON.parse(atob(decodeURIComponent(encodedLoginData)));
//                     localStorage.setItem('agentInfo', JSON.stringify(loginData));
//                 }
//             } else if (type === 'A') {
//                 localStorage.setItem('token', token);
//                 const loginData = JSON.parse(atob(decodeURIComponent(encodedLoginData)));
//                 localStorage.setItem('adminInfo', loginData);
//             } else if (type === 'D') {
//                 localStorage.setItem('developertoken', token);
//             }

//             // Remove URL parameters
//             const cleanUrl = window.location.origin + window.location.pathname;
//             window.history.replaceState({}, document.title, cleanUrl);

//             // Reload so AuthContext rehydrates
//             window.location.reload();
//         }
//     }, []);

//     return null;
// };

// export default TokenSync;
// TokenSync.js
import { useEffect } from 'react';

const TokenSync = () => {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const type = urlParams.get('type');
        const loginData = urlParams.get('loginData');

        if (token && type) {
            localStorage.setItem('type', type);

            if (type === 'E') {
                localStorage.setItem('agenttoken', token);
                if (loginData) {
                    localStorage.setItem('agentInfo', JSON.stringify(JSON.parse(atob(decodeURIComponent(loginData)))));
                }
            }

            // Remove from URL
            const clean = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, clean);

            // Force reload so AuthContext reads fresh localStorage
            window.location.reload();
        }
    }, []);

    return null;
};

export default TokenSync;
